function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 142.225h512v56.888H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 199.112h512V256H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 312.888h512v56.888H0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 369.775h512v56.888H0z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 56.954,
  fill: "#f0f0f0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M276.863 258.903L256 249.862s4.881-16.201 5.141-17.31c.19-.81.292-1.655.292-2.523 0-3.074-1.245-5.857-3.26-7.87l5.247-5.247a18.49 18.49 0 00-13.117-5.433 18.49 18.49 0 00-13.117 5.433l5.247 5.247a11.09 11.09 0 00-3.26 7.87c0 1.124.17 2.207.48 3.23l-7.9 7.9h14.357s-5.936 8.915-9.176 16.237c-3.24 7.322.045 16.259 7.534 19.588l4.33 1.924 7.202 6.771v7.421l-7.421 7.421h14.84v-14.84l6.771-6.771h14.004c.068-.139.138-.275.201-.417 3.331-7.494-.042-16.262-7.532-19.59z"
});

const SvgUganda = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUganda, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uganda.9448a097.svg";
export { ForwardRef as ReactComponent };